import type {
	GetResourcesQueryParams,
	GetResourceThemesQueryParams,
	PaginatedResponse,
	Resource,
	ResourceThemeWithResources,
} from "@dune/types";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import { resourcesQueryKeys } from "../query-keys/resources.query-keys";

const getResources = async (
	params?: GetResourcesQueryParams,
): Promise<PaginatedResponse<Resource>> => {
	const { data } = await privateAxios.get<PaginatedResponse<Resource>>(
		"/resources",
		{ params },
	);
	return data;
};

export const getResourceFileUrl = async (
	resourceId: number,
): Promise<string> => {
	const { data } = await privateAxios.get<string>(`/resources/${resourceId}/file-url`);
	return data;
};

const getResourceThemes = async (
	params?: GetResourceThemesQueryParams,
): Promise<ResourceThemeWithResources[]> => {
	const { data } = await privateAxios.get<ResourceThemeWithResources[]>(
		"/resources/themes",
		{
		params,
		},
	);
	return data;
};

export const useGetResources = (
	params?: GetResourcesQueryParams,
	options?: { enabled?: boolean },
) => {
	return useQuery({
		queryKey: resourcesQueryKeys.list(params),
		queryFn: () => getResources(params),
		placeholderData: keepPreviousData,
		enabled: options?.enabled ?? true,
	});
};

export const useGetResourceThemes = (
	params?: GetResourceThemesQueryParams,
) => {
	return useQuery({
		queryKey: resourcesQueryKeys.themes(params),
		queryFn: () => getResourceThemes(params),
	});
};
